<template>
  <v-container>
    <v-layout row>
    <v-flex xs12>
      <zoompick> helloworld</zoompick>
    </v-flex>
  </v-layout>
      <v-layout row>
    <v-flex xs12>
      <brewstatus></brewstatus>
    </v-flex>
  </v-layout>
  </v-container>
</template>
<script>
import zoompick from '@/components/animations/ZoomPicker.vue'
import brewstatus from '@/components/visualization/BrewStatus.vue'
export default {
  data () {
    return {}
  },
  components: {
    zoompick, brewstatus
  }
}
</script>


// WEBPACK FOOTER //
// src/components/expressModules/ZyptoBrewDemo.vue